// routes
// theme
// components
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import ScrollToTop from './components/ScrollToTop';
import Settings from './components/settings';
import ThemeColorPresets from './components/ThemeColorPresets';
import QueryClientProvider from './providers/queryCientProvider';
import Router from './routes';
import ThemeProvider from './theme';
import './style.css';

export default function App() {
  return (
    <QueryClientProvider>
      <ThemeProvider>
        <ThemeColorPresets>
          <NotistackProvider>
            <ProgressBarStyle />
            <Settings />
            <ScrollToTop />
            <Router />
          </NotistackProvider>
        </ThemeColorPresets>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
// https://mui.com/store/items/berry-react-material-admin/
